export const fluidImage = (theme) => ({
    /* Styles applied to the root element. */
    root: {
        display: "block",
        //visibility: 'hidden',
        opacity: "0",
        textAlign: "center",
    },
    fluid: {
        width: "auto",
        height: "auto",
        margin: "auto",
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
    loaded: {
        //visibility: 'visible',
        transition: "opacity 200ms ease-out",
        opacity: "1",
    },
});
